<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>CPR nummer</label>
        <app-let-input-cpr formControlName="cpr" />
      </div>
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Status</label>
        <p-select
          [options]="afsendelseOptions"
          formControlName="status"
          placeholder="Vælg"
          appendTo="body"
          [showClear]="true" />
      </div>
      <div class="flex gap-4" style="width: 340px">
        <div class="control">
          <label>Starttidspunkt</label>
          <p-datePicker
            formControlName="startTidspunktDate"
            dateFormat="dd-mm-yy"
            [showIcon]="true"
            [showTime]="true"
            [hourFormat]="'24'"
            appendTo="body" />
        </div>
        <div class="control">
          <label>Sluttidspunkt</label>
          <p-datePicker
            formControlName="slutTidspunktDate"
            dateFormat="dd-mm-yy"
            [showIcon]="true"
            [showTime]="true"
            [hourFormat]="'24'"
            appendTo="body" />
        </div>
      </div>
      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="dokAfsendelseService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
    @if (dokAfsendelseService.datasource.error()) {
      <p-message
        [text]="dokAfsendelseService.datasource.error()"
        severity="error"
        styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
